import "./LatestNews.css";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Skeleton from "../../../../components/Skeleton";
import { Helmet } from "react-helmet-async";
import logo from "../../../../components/images/logo.png";

const LatestNews = ({ dark, MyBaseUrl }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);

  const CACHE_KEY = "latest_news";

  const fetchPosts = async (pageNumber = 1, append = false) => {
    try {
      if (pageNumber === 1) {
        setLoading(true);
      } else {
        setLoadingMore(true);
      }

      const res = await fetch(
        `${MyBaseUrl}/posts/latest?page=${pageNumber}`
      );

      const data = await res.json();

      const newPosts = data?.data?.data || [];
      const meta = data?.data?.meta;

      if (append) {
        setPosts((prev) => [...prev, ...newPosts]);
      } else {
        setPosts(newPosts);
      }

      setLastPage(meta?.last_page);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    const loadInitialPages = async () => {
      let currentPage = 1;

      for (let i = 0; i < 1; i++) {
        await fetchPosts(currentPage, i !== 0);
        currentPage++;
      }

      setPage(currentPage);
    };

    loadInitialPages();
  }, []);

  const loadMorePages = async () => {
    if (lastPage && page > lastPage) return;

    let currentPage = page;

    for (let i = 0; i < 1; i++) {
      if (lastPage && currentPage > lastPage) break;

      await fetchPosts(currentPage, true);
      currentPage++;
    }

    setPage(currentPage);
  };

  return (

    <>
<Helmet>

  <title>Latest Football News, Transfers & Breaking Stories | FadaSports</title>

  <meta
    name="description"
    content="Get the latest football news, breaking stories, transfer updates, match reports, injury news, and analysis from top leagues around the world on FadaSports."
  />

  <meta
    name="keywords"
    content="
      football news,
      latest sports news,
      transfer news,
      breaking football news,
      match reports,
      football updates,
      Premier League news,
      Champions League news,
      FadaSports
    "
  />

  <meta name="author" content="FadaSports" />

  <meta name="robots" content="index, follow, max-image-preview:large" />

  <meta name="theme-color" content="#000000" />

  <link
    rel="canonical"
    href="https://fadasports.com/latest-news"
  />

  {/* OPEN GRAPH */}
  <meta property="og:type" content="website" />

  <meta property="og:site_name" content="FadaSports" />

  <meta property="og:url" content="https://fadasports.com/latest-news" />

  <meta
    property="og:title"
    content="Latest Football News, Transfers & Updates | FadaSports"
  />

  <meta
    property="og:description"
    content="All the latest football news, transfer updates, match reports and breaking stories from around the world."
  />

  <meta
    property="og:image"
    content={logo}
  />

  <meta property="og:locale" content="en_US" />

  <meta name="twitter:card" content="summary_large_image" />

  <meta
    name="twitter:title"
    content="Latest Football News | FadaSports"
  />

  <meta
    name="twitter:description"
    content="Breaking football news, transfers, and match updates from top leagues worldwide."
  />

  <meta
    name="twitter:image"
    content={logo}
  />

  <meta name="twitter:site" content="@FadaSports" />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",

      name: "Latest Football News - FadaSports",

      description:
        "A collection of the latest football news, transfers, match reports, and breaking stories from FadaSports.",

      url: "https://fadasports.com/latest-news",

      publisher: {
        "@type": "Organization",
        name: "FadaSports",
        logo: {
          "@type": "ImageObject",
          url: {logo}
        }
      }
    })}
  </script>

</Helmet>

    <div className="homer">
      <div
        className="latestNews"
      >

        {loading ? (
          
                <Skeleton dark={dark} count={6} />
        ) : posts.length <= 0 ? (
          <p style={{ textAlign: "center", marginTop: "40px" }}>
            No news available
          </p>
        ) : (
          <>
            <section className="firstsection">
              <h1 style={dark ? { color: "#fafafa" } : {}}>
                Latest News
              </h1>
              {posts.slice(0, 1).map((item, index) => {
                return (
                  <NavLink
                    to={`/news/${item.slug}`}
                    key={item.id || index}
                    className="newsCard"
                    style={dark ? { backgroundColor: "#333333ff" } : {}}
                  >
                    <div className="imgWrap">
                      <img src={item.image} alt="" />
                    </div>

                    <div className="content deep">
                      <h3 style={dark ? { color: "#fff" } : {}}>
                        {item.title}
                      </h3>

                      <div className="meta">
                        <span>
                          {item?.author?.name}
                        </span>

                        <span>
                          {item?.published_at &&
                            new Date(item?.published_at).toLocaleDateString(
                              "en-US",
                              {
                                month: "short",
                                day: "2-digit",
                                year: "numeric",
                              }
                            )}
                        </span>
                      </div>
                    </div>
                  </NavLink>
                );
              })}
            </section>

            <div className="latestGrid">
              {posts.slice(1).map((item, index) => {
                return (
                  <NavLink
                    to={`/news/${item.slug}`}
                    key={item.id || index}
                    className="newsCard"
                    style={dark ? { backgroundColor: "#333333ff" } : {}}
                  >
                    <div className="imgWrap">
                      <img src={item.image} alt="" />
                    </div>

                    <div className="content">
                      <h3 style={dark ? { color: "#fff" } : {}}>
                        {item.title}
                      </h3>

                      <div className="meta">
                        <span>
                          {item?.author?.name}
                        </span>

                        <span>
                          {item?.published_at &&
                            new Date(item?.published_at).toLocaleDateString(
                              "en-US",
                              {
                                month: "short",
                                day: "2-digit",
                                year: "numeric",
                              }
                            )}
                        </span>
                      </div>
                    </div>
                  </NavLink>
                );
              })}
            </div>

            {lastPage && page <= lastPage && (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <button
                  onClick={loadMorePages}
                  disabled={loadingMore}
                  className={`view-all-btn ${dark ? "dark" : ""}`}
                >
                  {loadingMore ? "Loading..." : "See More"}
                </button>
              </div>
            )}
          </>
        )}
      </div>

      
    </div>
    </>
  );
};

export default LatestNews;